<template>
    <div>
        <v-app class="p-4">
            <!--        <ads-selector></ads-selector>-->
            <div class="p-0 mt-5 pt-5" style="border: none!important;">
                <div class="row col-md-8 mx-auto px-5 pb-0 mb-5" style="border-bottom: 1px dotted #1c0152">
                    <div class="col-md-6 text-right">
                        <p>هزینه هر متن : {{ costPerText = panelInfo.price  }} <span class="text-danger">﷼</span></p>
                    </div>
                    <div class="col-md-6 text-left">
                        <p>هزینه تولید جملات مترادف : {{ costPerSentence = panelInfo.price * requestCount }} <span class="text-danger">﷼</span></p>
                    </div>
                </div>
                <categoryselector :page-name="namePage" @category-schema="getSchema" @category-fields="getFields" ref="category" :multiAdsCat="true"></categoryselector>
                <div class="col-md-11 mx-auto">
                    <div class="col-md-8 mx-auto px-0 my-0 py-0">
                        <city-selector ref="city" :force="true"></city-selector>
                    </div>
                    <div class="col-md-8 mx-auto px-0 my-0 py-0">
                        <pic-selector :count="250"></pic-selector>
                    </div>
                </div>
                <div class="px-5 mx-1 my-0 py-0">
                    <input-maker :param="schema" :ui_schema="this.ui_schema" :fields="this.fields"></input-maker>
                </div>
                <div class="row col-md-8 px-5 mx-auto my-0 py-0">
                    <div class="col-md-6 mx-auto my-0 py-0">
                        <v-text-field class="my-0 py-0" outlined clearable clear-icon="mdi-close-circle-outline" @keypress="allowOnlyNumbers($event)" v-model="requestCount" :rules="requestRules" dense label="تعداد درخواست"
                                      required
                                      type="number"
                                      name="count"
                                      min="1"
                                      max="25"
                                      maxLength="2"
                                      prepend-inner-icon="fas fa-pencil-alt">
                        </v-text-field>
                    </div>
                    <div class="col-md-6 mx-auto my-0 py-0">
                        <v-text-field outlined clearable clear-icon="mdi-close-circle-outline" :error-messages="message" v-model="keyWord" dense label="نام محصول / خدمات" required name="keyword"
                                      prepend-inner-icon="fas fa-pencil-alt">
                        </v-text-field>
                    </div>
                </div>
                <setting-ads @multiAds="multiTime" time-require="false"></setting-ads>
                <div class="col-md-8 mr-auto">
                    <v-btn @click="submitText" class="submit-btn float-left">
                         <span class="fa fa-save ml-1" style="font-size: 1.3rem"></span>
                        ثبت خرید</v-btn>
                </div>
            </div>
        </v-app>
    </div>

</template>

<script>
import PicSelector from "@/view/pages/uploadCenter/picSelector";
import SettingAds from "@/view/pages/ads/settingAds";
import InputMaker from "@/view/pages/ads/inputMaker";
import AdsSelector from "@/view/pages/ads/adsSelector";
import Inputs from "@/view/pages/ads/inputs";
import Automatics from "@/view/pages/ads/timeHandelers/automatics";
import CitySelector from "@/view/pages/ads/citySelector";
import Categoryselector from "@/view/pages/ads/categorySelector";
import TitleRibbon from "@/view/pages/uiBeautifier/titleRibbon";
import {Bus} from "@/main";
import ButtonTempl from "@/view/pages/uiBeautifier/buttonTempl";

export default {
    name: "unrepeatAbleText",
    components: {
        ButtonTempl,
        TitleRibbon, PicSelector, SettingAds, InputMaker, AdsSelector, Inputs, Automatics, CitySelector, Categoryselector},
    props: {
        ui_schema: {
            type: Array,
            default() {
                return []
            }
        },
        fields: {
            type: Array,
            default() {
                return [];
            }
        },
        multi_time: {
            type: Boolean,
            default: false
        },

    },
    data() {
        return {
            picker: '',
            requestCount: '',
            costPerText: '',
            costPerSentence: 0,
            keyWord: '',
            message: '',
            submitMessage: '',
            namePage: this.pageName,
            requestRules: [
                v => !!v || 'تعداد درخواست را وارد کنید',
                v => (v > 0 && v < 26) || 'تعداد درخواست باید بین 1 تا 25 باشد',
            ],
            panelInfo:[],
            schema: {
               advertise:{
                   category: "",
                   location: {
                       city: "",
                       neighborhood: ""
                   },
                   contact: {
                       chat_enabled: false,
                       hide_phone: false,
                   },
               },
                auto_pay:'',
            }
        }
    },
    methods: {
        getSchema: function (value) {
            this.ui_schema = value;
        },
        getFields: function (val) {
            this.fields = val;
        },
        multiTime: function (value) {
            this.multi_time = value;
        },
        submitText(){
            const data = this.schema
            $.ajax({
                url:`${url}/shop/default`,
                method: "POST",
                fn:this.submitText,
                headers: {
                    Authorization: Token,
                    ACCEPT: 'application/json',
                    "Content-Type":"application/json"
                },
                data:JSON.stringify({
                    data:data,
                    keyword:this.keyWord,
                    count:this.requestCount
                }),
            });
        },
        getPanel() {
            $.ajax({
                url: `${url}/user/panels`,
                fn:this.getPanel,
                headers: {
                    Authorization: Token,
                    "ACCEPT": 'application/json',
                },
                type: 'GET',
                success: (data) => {
                    this.panelInfo = data.data.unique_pack
                }
            })
        },
        allowOnlyNumbers(value) {
            if (typeof Number(value.key) != "string") {
                let allowedKeys = [8, 46, 38, 40, 37, 39];
                const keypressed = value.which || value.keyCode;
                if (/[^0-9\s]+/.test(value.key)) {
                    if (allowedKeys.every(e => e !== keypressed)) {
                        value.preventDefault();
                    }
                } else return true
            }
        },
    },
    watch: {
        keyWord: function (value) {
            this.keyWord = value;
            const sillabels = this.keyWord.split(' ').filter(x => x);
            if (sillabels.length < 2) {
                this.message = 'حداقل 2 کلمه باید وارد شود';
            } else if (sillabels.length >= 5) {
                this.message = 'حداکثر 4 کلمه باید وارد شود';
            } else {
                this.message = '';
            }

        },
    },
    mounted() {
        this.getPanel();
        Bus.$on('cityInfo', (value) => {
            this.schema.advertise.location.city = value.city;
            this.schema.advertise.location.neighborhood = value.neighborhood;
        });

        Bus.$on('selectedImage', (value) => {
            this.schema.advertise.images = value;
        });

        Bus.$on('contact', (value) => {
            this.schema.advertise.contact.chat_enabled = value.chat_enabled;
            this.schema.advertise.contact.hide_phone = value.hide_phone;
            this.schema.auto_pay = value.auto_pay;
        });

        Bus.$on('category-current', (current) => {
            this.schema.advertise.category = current;
        });
    }
}
</script>

<style scoped>

</style>